import styled from 'styled-components';
import { borderRadius, colors } from 'ui/theme';
import { Asterisk16 } from 'ui/icons/aurora/16px/Asterisk16';
import { getIconColor, isOptionSelected } from './utils';

const StyledAsteriskIcon = styled(Asterisk16)`
  border-radius: ${borderRadius.xl};
  border: 2px solid ${colors.cyan50};

  &[data-selected='false'] {
    border-color: ${colors.textSecondary};
  }
`;

export const OrIcon = ({ color }: { color?: string }) => {
  const isSelected = isOptionSelected(color);
  return (
    <StyledAsteriskIcon
      data-temporary-fix={false}
      data-selected={isSelected}
      color={getIconColor(colors.cyan50, color)}
    />
  );
};
